import {combineReducers} from 'redux';
import aligningSlice from './aligningSlice';
import userSlice from './userSlice';
import anticipatingSlice from './anticipatingSlice';
export default combineReducers({
  aligning: aligningSlice,
  user: userSlice,
  anticipating: anticipatingSlice,
});
